import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../interfaces/user';

@Component({
    selector: 'user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserAvatarComponent implements OnInit {
  @Input('user') user: User;
  constructor() {}

  ngOnInit(): void {}
  getPhotoForDisplay(): string {
    if (this.user.user_profile && this.user.user_profile.avatar_photo) {
      return 'data:image/jpeg;base64,' + this.user.user_profile.avatar_photo;
    }
    return '';
  }
}
